import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { MemberService } from '../../../../../../../definition/member/service/member.service';

@Component({
  selector: 'app-member-input',
  templateUrl: './member-input.component.html',
  styleUrl: './member-input.component.scss',
})
export class MemberInputComponent {
  @Output() selectOn = new EventEmitter<{
    selectedMember: any;
    selectedMemberDetail: any;
  }>();

  isOpen: boolean = false;
  first: number = 0;
  rows: number = 20;
  filter: any = {
    name: undefined,
    surname: undefined,
    phoneNumber: undefined,
    idNumber: undefined,
    member_id: undefined,
    contract_id: undefined,
    contract_status: undefined,
    pageIndex: this.first,
    pageSize: this.rows,
  };

  totalRecords: number = 0;
  loading: boolean = false;
  genders: { label: string; value: string }[] = [
    { label: 'Erkek', value: 'Male' },
    { label: 'Kadın', value: 'Female' },
  ];
  members: any[] = [];
  filteredMembers: any[] = [];
  selectedMember: any;
  selectedMemberDetail: any;
  contractStatuses = ['Aktif', 'Pasif', 'İptal'];
  readonlyDatas: {
    fullname: null | string;
    memberNo: null | number;
    contractNo: null | number;
  } = {
    fullname: null,
    memberNo: null,
    contractNo: null,
  };
  @Input() isReadOnly=false;

  shouldLoadData: boolean =false;
  constructor(
    private readonly memberService: MemberService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  async loadData(event: TableLazyLoadEvent) {
    if(!this.shouldLoadData){
      return;
    }
    this.first = event.first!;
    this.rows = event.rows!;
    const page = Math.floor(this.first / this.rows);
    const params = {
      pageIndex: page,
      pageSize: this.rows,
    };
    this.loading = true;
    this.cdr.detectChanges();

    this.memberService
      .getMembersWithDetails({ ...this.filter, ...params })
      .subscribe({
        next: (res) => {
          this.members = res;
          this.filteredMembers = res;
          this.totalRecords =
            this.members?.length > 0 ? this.members[0]?.satir_sayisi : 0;
          this.loading = false;
          if (this.filter.contract_status) {
            this.onStatusFilterChange();
          }
        },
        error: (err) => {
          this.loading = false;
        },
      });
  }

  clearFilters() {
    this.filter = {
      name: undefined,
      surname: undefined,
      phoneNumber: undefined,
      idNumber: undefined,
      member_id: undefined,
      contract_id: undefined,
      contract_status: undefined,
      pageIndex: this.first,
      pageSize: this.rows,
    };
    this.first = 0;
    this.loadData({ first: 0, rows: this.rows });
  }

  onHide() {
    this.filter = {
      name: undefined,
      surname: undefined,
      phoneNumber: undefined,
      idNumber: undefined,
      member_id: undefined,
      contract_id: undefined,
      contract_status: undefined,
      pageIndex: this.first,
      pageSize: this.rows,
    };
    this.members = [];
    this.filteredMembers = [];
    this.selectedMember = null;
    this.selectedMemberDetail = null;
    this.first = 0;
    this.rows = 20;
  }

  confirmSelection() {
    if (this.selectedMemberDetail && this.selectedMember) {
      this.selectOn.emit({
        selectedMember: this.selectedMember,
        selectedMemberDetail: this.selectedMemberDetail,
      });
      this.readonlyDatas = {
        fullname: this.selectedMember?.fullname,
        memberNo: this.selectedMember?.uyelik_id,
        contractNo: this.selectedMemberDetail?.sozlesme_id,
      };
      this.isOpen = false;
    }
  }

  clearSearch() {
    this.readonlyDatas = {
      fullname: null,
      memberNo: null,
      contractNo: null,
    };
    this.selectOn.emit();
  }

  onStatusFilterChange() {
    this.selectedMember = null;
    this.selectedMemberDetail = null;
    this.filteredMembers = [...this.members];
    if (this.filter.contract_status !== null) {
      this.filteredMembers = this.members.filter((member) =>
        member.serviceDetails?.some(
          (detail: any) =>
            detail?.sozlesme_durumu === this.filter?.contract_status
        )
      );
    }
    this.totalRecords = this.filteredMembers?.length;
  }

  search() {
    this.shouldLoadData = false;
    this.isOpen = true;
  }

  onFilterClick() { /**MERVEEE */
    this.shouldLoadData = true;
    this.loadData({ first: 0, rows: this.rows });

  }

  memberChange(e: any) {
    this.selectedMemberDetail = null;
  }
  setMemberValue(data: {
    memberFullname: null | string;
    memberNo: null | number;
    memberContractNo: null | number;
  }) {
    this.readonlyDatas = {
      fullname: data?.memberFullname,
      memberNo: data?.memberNo,
      contractNo: data?.memberContractNo,
    };
  }
}
